const themeCleanNames = {
  JumpIntoKeyboarding: 'Jump into Keyboarding!',
  LetsEat: "Let's Eat!",
  OffToWork: 'Off to Work',
  OnTheGo: 'On the Go',
  WildAboutAnimals: 'Wild About Animals',
  LetsPlay: "Let's Play",
  StartMusic: 'Start Music',
  MathMix: 'Math Mix',
  SingPlay: 'Sing & Play',
  FamousFaces: 'Famous Faces',
  GreekLatin: 'Greek Latin',
  BonesBodies: 'Bones & Bodies',
  GreatGrammar: 'Great Grammar',
  OhLook: 'Oh Look!',
  GoGeography: 'Go Geography',
  WordsWriters: 'Words & Writers',
  SuperWords: 'Super Words',
  PeoplePower: 'People Power',
  WaterWater: 'Water, Water!',
  ArtStart: 'Art Start',
  SpeedyKid: 'Speedy Keyboard Kid'
};

const themeObjs = {
  JumpIntoKeyboarding: 0, // converts a theme into an index into the colors & awards arrays
  LetsEat: 1,
  OffToWork: 2,
  OnTheGo: 3,
  WildAboutAnimals: 3,
  LetsPlay: 2,
  StartMusic: 1,
  MathMix: 2,
  SingPlay: 1,
  FamousFaces: 3,
  GreekLatin: 2,
  BonesBodies: 4,
  GreatGrammar: 5,
  OhLook: 1,
  GoGeography: 3,
  WordsWriters: 4,
  SuperWords: 2,
  PeoplePower: 3,
  WaterWater: 4,
  ArtStart: 1,
  SpeedyKid: 3
};

const themeColorsPrimA = ['#C18AD3', '#66CC66', '#00BCBC', '#FFCC33', '#EC6A3E', '#EA9138'];
const themeColorsLiteA = ['#DCB2EA', '#8CE98C', '#77D2D2', '#FEDF83', '#F79270', '#F8B16A'];
const themeAwardsA = ['medal', 'cup', 'plaque', 'ribbon', 'shield', 'star'];

const getCurrentTheme = theme => {
  if (!theme) return {};

  return {
    id: theme,
    isSpeedyKid: theme === 'SpeedyKid',
    name: themeCleanNames[theme].toString(),
    color: themeColorsPrimA[themeObjs[theme]],
    lightColor: themeColorsLiteA[themeObjs[theme]],
    awardName: themeAwardsA[themeObjs[theme]],
    index: themeObjs[theme]
  };
};

const getAwardName = theme => themeAwardsA[themeObjs[theme]];
const getThemeColor = theme => themeColorsPrimA[themeObjs[theme]];

export {
  themeCleanNames,
  themeObjs,
  themeColorsPrimA,
  themeColorsLiteA,
  themeAwardsA,
  getCurrentTheme,
  getAwardName,
  getThemeColor
};
